import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare let Argyle: any;

const ARGYLE_SDK_URL = 'https://plugin.argyle.com/argyle.web.v5.js';

@Injectable()
export class ArgyleService {

  private _sdkLoaded: boolean = false;
  private _sdkLoadPromise: Promise<any> | null = null;

  /**
   * Loads the Argyle Link SDK from the CDN if not already loaded.
   * Returns a reference to the global Argyle object.
   */
  public loadArgyleSdk(): Promise<any> {
    if (this._sdkLoaded && typeof Argyle !== 'undefined') {
      return Promise.resolve(Argyle);
    }

    if (this._sdkLoadPromise) {
      return this._sdkLoadPromise;
    }

    this._sdkLoadPromise = new Promise<any>((resolve, reject) => {
      // Check if the script is already on the page
      if (typeof Argyle !== 'undefined') {
        this._sdkLoaded = true;
        resolve(Argyle);
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = ARGYLE_SDK_URL;
      script.async = true;
      script.onload = () => {
        if (typeof Argyle !== 'undefined') {
          this._sdkLoaded = true;
          resolve(Argyle);
        } else {
          reject(new Error('Argyle SDK loaded but Argyle global not found'));
        }
      };
      script.onerror = () => {
        this._sdkLoadPromise = null;
        reject(new Error('Failed to load Argyle SDK from CDN'));
      };
      document.head.appendChild(script);
    });

    return this._sdkLoadPromise;
  }

  /**
   * Extracts the user_token query parameter from an Argyle connect URL.
   */
  public extractUserToken(widgetUrl: string): string {
    const url = new URL(widgetUrl);
    return url.searchParams.get('user_token') ?? '';
  }

  /**
   * Returns whether to use Argyle sandbox mode based on the environment.
   */
  public isSandbox(): boolean {
    return environment.environment !== 'Prod';
  }
}
